export default "__VITE_ASSET__D71vFBKb__"